<div class="app-container">
  <page-header [icon]="'far-truck'" [title]="'suppliers'">
    <ng-container class="header-button">
      @if (canCreate()) {
        <btn
          [routerLink]="['/supplier']"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [label]="'supplier.create'"
          [title]="'supplier.create' | translate"
          [dataCyAttribute]="'go-supplier'"
        ></btn>
      }
    </ng-container>
  </page-header>

  <section class="content">
    <app-filter-form
      [filters]="queryFilters()"
      [filtersForExport]="queryFilters()"
      [entity]="'suppliers'"
      (onSubmit)="querySuppliers.refetch()"
      (onClearClick)="clearFilters()"
      [loading]="false"
      [isFilterInvisible]="true"
      [areExportsInFilter]="false"
      [totalItems]="totalItems()"
      (onExportResult)="querySuppliers.refetch()"
    >
      <form-row-input
        [model]="filters().name"
        (modelChange)="setFilterName($event)"
        (keydown.enter)="querySuppliers.refetch()"
        [label]="'suppliers.name'"
        [icon]="'far-list'"
        [dataCyAttribute]="'supplier-name-filter'"
      ></form-row-input>
    </app-filter-form>

    <app-base-listing
      [listName]="'suppliers'"
      [query]="querySuppliers"
      [columns]="listingColumns"
      [selectedColumns]="listingColumns"
      [sortProp]="sortProp"
      [sortDir]="sortDir"
    ></app-base-listing>
  </section>
</div>
